import { create } from 'zustand';

interface ContestantFiltersState {
  search: string;
  contestId: string;
  sortBy: string;
  setSearch: (search: string) => void;
  setContestId: (contestId: string) => void;
  setSortBy: (sortBy: string) => void;
  reset: () => void;
}

export const useContestantFilters = create<ContestantFiltersState>((set) => ({
  search: '',
  contestId: '',
  sortBy: '',
  setSearch: (search) => set({ search }),
  setContestId: (contestId) => set({ contestId }),
  setSortBy: (sortBy) => set({ sortBy }),
  reset: () => set({ search: '', contestId: '', sortBy: '' }),
}));
